function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 7a5 5 0 100 10 5 5 0 000-10z",
  fill: "currentColor"
});

var SvgDot = function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDdDOS4yMzgzOSA3IDcgOS4yMzgzOSA3IDEyQzcgMTQuNzYxNiA5LjIzODM5IDE3IDEyIDE3QzE0Ljc2MTYgMTcgMTcgMTQuNzYxNiAxNyAxMkMxNyA5LjIzODM5IDE0Ljc2MTYgNyAxMiA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgDot as ReactComponent };